/* import __COLOCATED_TEMPLATE__ from './ticket-links-placeholder.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();